<template>
  <div class="menu-warrper">
    <div class="menu-view" :class="userMenuArray.length > 1 ? 'marbom' : ''">
      <div v-for="(item1, index1) in userMenuArray" :key="index1" class="menu-view-row">
        <div class="menu-view-item" v-for="(item2) in item1" :key="item2.icon" v-track="{ functionName: item2.name }"
             :class="item2.name === '课程学习'? 'course-entrance':''"
             @click="jump(item2)">
          <div class="tab-icon-box">
            <img src="@/assets/images/home/new-icon.png" alt="" v-if="isNewVersion(item2)" class="new-icon">
            <img class="tab-icon" v-if="item2 && item2.icon" :src="require(`@/${item2.icon}`)" alt="">
          </div>
          <div class="tab-text">
            <div>{{ item2 && item2.name }}</div>
          </div>
          <div v-if="messageCount > 0 && item2.name === '系统消息'" class="count">
            {{ messageCount }}
          </div>
        </div>
      </div>
    </div>
    <custom-dialog
      :visible.sync="cDialog.visible"
      @cancel="cDialog.cancel"
      @confirm="cDialog.confirm"
      @close="cDialog.close"
      v-bind="cDialog"
    >
      <div class="txts">{{ cDialog && cDialog.content }}</div>
    </custom-dialog>
  </div>
</template>

<script>
import {splitArray} from '@/utils/util'
import {getUserIdentity, setSha, traceClickURL} from '../utils/util'
import {zoneUserVisitId} from '@/api/zone'
import CustomDialog from '@/views/cartoJourney/components/CustomDialog.vue'
import {getUsersRole} from '@/api/cartoJourney.js'
import {postRemind} from '../api/simulator'

export default {
  name: 'UserMenu',
  components: {
    CustomDialog
  },
  props: {
    newVersion: {
      type: Array,
      default: () => []
    },
    notice_menu: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      messageCount: 0,
      cDialog: {
        visible: false,
        showCancelButton: false,
        confirmButtonText: '我知道了',
        content: '',
        cancel: () => {
          this.cDialog.visible = false
        },
        confirm: () => {
          this.cDialog.visible = false
        },
        close: () => {
          this.cDialog.visible = false
        }
      },
      userRole: '',
      userIdentity: getUserIdentity()
    }
  },
  async created() {
    await this.getUserRole()
  },
  computed: {
    isNewVersion() {
      return (item) => {
        const open = this.newVersion.find(a => a.code === item.code)
        return open
      }
    },
    userMenuArray() {
      let menus = JSON.parse(JSON.stringify(this.$store.getters.permissionList))
      let newArr = []
      menus.map(item => {
        if (item.type === '1' && item.accessible === true && item.children.length === 0) {
          newArr.push(item)
        }
        if (item.children.length > 0 && item.accessible === true) {
          let childArr = item.children.filter(child => {
            child.ordered = item.ordered
            return child.type === '1'
          })
          newArr = newArr.concat(childArr)
        }
        menus = newArr
      })
      menus = menus.sort((a, b) => {
        return a.ordered - b.ordered
      })
      return splitArray(menus, 5)
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  methods: {
    async handlePostRemind(item) {
      const a = this.newVersion.find(a => a.code === item.code)
      if (!a) return
      await postRemind(
        {
          'readType': a.value,
          'readTypeName': '版本更新',
          'iepUserId': this.userInfo.id
        }
      )
    },
    async jump(item) {
      if (item.path.indexOf('kdSimulator') > -1) {
        if (this.userIdentity.veevaStatus === '待验证' && this.userIdentity.isDueDate) {
          this.cDialog.visible = true
          this.cDialog.title = '提示'
          this.cDialog.content = '敬请期待!'
          return
        }
      }
      await this.handlePostRemind(item)
      if (item.component.indexOf('casesharing') > -1) {
        let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
        let url = `${item.component}${openidBindli}`
        localStorage.setItem('functionUrl', url)

        setTimeout(() => {
          traceClickURL()
        })
        window.location.href = url
        return
      } else if (item.component.indexOf('iepwechat') > -1) {
        // 文献解读
        this.$router.push({
          path: `/articleList`
        })
        // let openid = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
        // let iepTxt = `&nickname=123&avatar=123&subscribe=1`
        // let url = `${item.component}${openid}${iepTxt}`
        // localStorage.setItem('functionUrl', url)

        // setTimeout(() => { traceClickURL() })
        // window.location.href = url
        return
      }
      if (item.path.indexOf('train') > -1) {
        window && window.sessionStorage.removeItem('trainFilter')
      }
      localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/${item.path}`)
      localStorage.removeItem('changeTabActive')
      localStorage.removeItem('changeGradeTabActive')
      if (item.path.indexOf('zoneList') > -1) {
        zoneUserVisitId({
          userId: this.userInfo.id,
          memberType: this.userInfo.memberType
        }).then(res => {
          if (res.data) {
            this.$router.push({
              path: `/zoneDetails?areaId=${res.data}`
            })
          } else {
            this.$router.push(item.path)
          }
        })
        return
      }
      if (item.path.indexOf('AIFV') > -1 && `${this.userInfo.memberType}` === '1') {
        item.path = '/aifvList'
      }
      if (item.path.indexOf('technology') > -1) {
        switch (item.name) {
          case '术式方案':
            this.$router.push(`${item.path}?firstClassify=1`)
            break
          case '技术前沿':
            this.$router.push(`${item.path}?firstClassify=2`)
            break
          case '专科发展':
            this.$router.push(`${item.path}?firstClassify=3`)
            break
          case '诊疗发展':
            this.$router.push(`${item.path}?firstClassify=4`)
            break
        }
        return
      }
      this.$router.push(item.path)
    },
    async getUserRole() {
      const res = await getUsersRole({userId: this.userInfo.id})
      if (res.code === 0) {
        this.userRole = res.data
      }
    },
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.menu-warrper {
  position: relative;
  width: 100%;
}

.menu-view {
  width: 100%;
  background-color: #ffffff;
  margin-top: 20px;

  &.marbom {
    margin-bottom: 10px;
  }

  .menu-view-row {
    background: #ffffff;
    border-radius: 5px 5px 0 0;
    padding-bottom: 10px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(5, 1fr);

    .menu-view-item {
      width: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      .tab-icon-box {
        width: 44px;
        height: 44px;
        margin-bottom: 4px;
        position: relative;

        .new-icon {
          position: absolute;
          right: 0;
          top: 0;
          width: 22px;
        }

        .tab-icon {
          width: 44px;
          height: 44px;
        }
      }

      .tab-text {
        font-size: 12px;
        font-weight: 500;
        color: #1f333f;
      }

      .count {
        position: absolute;
        top: 0;
        right: 10px;
        background: #ff0000;
        text-align: center;
        color: white;
        border-radius: 50%;
        font-size: 10px;
        font-weight: bold;
        min-width: 14px;
        height: 14px;
        width: 14px;
        // padding: 0 3px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .iframe {
    position: absolute;
    width: 100%;
    height: 250px;
    top: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserMenu.vue